import {stateManager} from "./stateManager";

/**
 * Действия по сделке
 * Навешиваем обработчики для различных действий
 */

/**
 * Типы действий со сделкой
 */
export const DealActionsEnums = {
  CHANGE_PARTICIPANT: 'changeParticipant',
  CHANGE_DOCUMENTS: 'changeDocuments',
  NEW_PARTICIPANT: 'newParticipant',
  CHANGE_REALTY: 'changeRealty',
  UPDATE_DEAL_DATA: 'updateDealData',
  UPDATE_DOCUMENT: 'updateDocument',
  DELETE_PARTICIPANT: 'deleteParticipant',
  XML_STATEMENT_CREATE: 'xmlStatementCreate'
}

/**
 * Отслеживаем изменения по сделке для контроля состояния сделки
 * @param {DealActionsEnums} action
 */
export const handleDealAction = (action) => {
  // действия со сделкой
  if ([
    DealActionsEnums.DELETE_PARTICIPANT,
    DealActionsEnums.CHANGE_PARTICIPANT,
    DealActionsEnums.CHANGE_DOCUMENTS,
    DealActionsEnums.CHANGE_REALTY,
    DealActionsEnums.UPDATE_DEAL_DATA,
    DealActionsEnums.UPDATE_DOCUMENT,
    DealActionsEnums.NEW_PARTICIPANT].includes(action)
  ) {
    stateManager.setState({
      isBlockedForRegistration: true,
      lastAction: action
    });
  }

  // Если сформировали заявление, то дергаем обработчик
  if (action === DealActionsEnums.XML_STATEMENT_CREATE) {
    stateManager.setState({
      isBlockedForRegistration: false,
      lastAction: action
    });
  }
}